/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion, parseDateTime } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrchestrateBlobMetadata as StorageOrchestrateBlobMetadata } from '../../models/storage/orchestrate-blob-metadata';

export interface ListBlobs$Params {
  storageStrategyName: string;
  linkData?: string | null;
}

export function listBlobs(http: HttpClient, rootUrl: string, params: ListBlobs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StorageOrchestrateBlobMetadata>>> {
  const rb = new RequestBuilder(rootUrl, listBlobs.PATH, 'get');
  if (params) {
    rb.query('storageStrategyName', params.storageStrategyName, {});
    rb.query('linkData', params.linkData, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r.clone({ body: reviveResponseBody(r.body) }) as StrictHttpResponse<Array<StorageOrchestrateBlobMetadata>>;
    })
  );
}

listBlobs.PATH = '/blob';

function reviveStorageOrchestrateBlobMetadata(value: any): any {
  if (value) {
    if (value["modified"] != null) {
      value["modified"] = parseDateTime(value["modified"]);
    }
  }
  return value;
}

function reviveResponseBody(body: any): any {
  if (body) {
    for (let i0 = 0; i0 < body.length; i0++) {
      if (body[i0] != null) {
        body[i0] = reviveStorageOrchestrateBlobMetadata(body[i0]);
      }
    }
  }
  return body;
}
